import React from 'react';

import SectionTitle from '../../../../components/section-title/SectionTitle';

import scss from './InspectorSection.module.scss';

function InspectorSection({ title, children }) {
  return (
    <section className={scss.section}>
      <SectionTitle title={title} />
      {children}
    </section>
  );
}

export default InspectorSection;
